import {
  LIST_BRANCH_HOLIDAY_REQUEST,
  LIST_BRANCH_HOLIDAY_SUCCESS,
  LIST_BRANCH_HOLIDAY_FAIL,
  CREATE_BRANCH_HOLIDAY_REQUEST,
  CREATE_BRANCH_HOLIDAY_SUCCESS,
  CREATE_BRANCH_HOLIDAY_FAIL,
  DETAIL_BRANCH_HOLIDAY_REQUEST,
  DETAIL_BRANCH_HOLIDAY_SUCCESS,
  DETAIL_BRANCH_HOLIDAY_FAIL,
  UPDATE_BRANCH_HOLIDAY_REQUEST,
  UPDATE_BRANCH_HOLIDAY_SUCCESS,
  UPDATE_BRANCH_HOLIDAY_FAIL,
  DELETE_BRANCH_HOLIDAY_REQUEST,
  DELETE_BRANCH_HOLIDAY_SUCCESS,
  DELETE_BRANCH_HOLIDAY_FAIL,
  LIST_BRANCH_HOLIDAY_RESET
} from '../../../constants/branches/holidays'

const initialState = {
  loading: false,
  holidays: [],
  error: null
}

const branchHolidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_HOLIDAY_REQUEST:
      return {
        loadingList: true
      }
    case LIST_BRANCH_HOLIDAY_SUCCESS:
      return {
        loadingList: false,
        holidays: action.payload
      }
    case LIST_BRANCH_HOLIDAY_FAIL:
      return {
        loadingList: false,
        error: action.payload
      }
    case LIST_BRANCH_HOLIDAY_RESET:
      return {
        loading: false,
        error: null,
        holidays: []
      }
    case CREATE_BRANCH_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case CREATE_BRANCH_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case CREATE_BRANCH_HOLIDAY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_BRANCH_HOLIDAY_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_BRANCH_HOLIDAY_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        holiday: action.payload
      }
    case DETAIL_BRANCH_HOLIDAY_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_BRANCH_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case UPDATE_BRANCH_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case UPDATE_BRANCH_HOLIDAY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DELETE_BRANCH_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DELETE_BRANCH_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false
      }

    case DELETE_BRANCH_HOLIDAY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default branchHolidaysReducer